"use client";
import { motion } from "framer-motion";
import { ContainerGlob } from "../../../componentsGLob/ContainerGlob";
import { DecorativeElements } from "../../../componentsGLob/Decorative/decorative-elements";
import { YouTubePlayer } from "./YoutubePlayer";
import { HERODIGI_DECORATIVES } from "./herodigi-decorative";
import { useTranslation } from "react-i18next";

const gradientText =
  "text-transparent bg-clip-text bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500";

export function HeroSection() {
  const { t } = useTranslation("heroDigital");

  return (
    <section
      id="home"
      className="relative w-full flex items-start justify-center pt-[5vh] pb-12 bg-white overflow-hidden"
    >
      {/* Elementi decorativi */}
      <div className="absolute inset-0 z-0">
        <DecorativeElements elements={HERODIGI_DECORATIVES} isEnabled={true} />
      </div>

      <ContainerGlob className="relative z-10">
        <div className="flex flex-col items-center text-center gap-6">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-4xl sm:text-5xl md:text-6xl font-bold text-gray-900 leading-tight"
          >
            <span className="block">{t("titlePart1")}</span>
            <span className={gradientText}>{t("titlePart2")}</span>
          </motion.h1>
          <div className="max-w-2xl space-y-4">
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="text-lg md:text-xl text-gray-600 leading-relaxed"
            >
              {t("paragraph1")}
            </motion.p>
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              className="text-lg md:text-xl text-gray-600 leading-relaxed"
            >
              {t("paragraph2")}
            </motion.p>
          </div>
          <div className="mt-8 w-full max-w-4xl">
            <YouTubePlayer
              videoId="Fu5LNq4Fypw"
              title={t("youtubeTitle")}
              className="rounded-xl shadow-xl"
            />
          </div>
        </div>
      </ContainerGlob>
    </section>
  );
}
